import React from "react";
import { Typography, Row, Col, Breadcrumb, Card, Table } from "antd";
import { TeamOutlined } from "@ant-design/icons";
import { useGetDownlineUserQuery } from "../../slices/usersApiSlice";

const { Title } = Typography;

const DownlinePage = ({ darkmode }) => {
  const { data, isLoading } = useGetDownlineUserQuery();

  const columns = [
    {
      title: "#",
      render: (_, __, index) => index + 1,
      width: 60,
    },
    {
      title: "User ID",
      dataIndex: "UserID",
    },
    {
      title: "Sponsor ID",
      dataIndex: "SponsorID",
    },
    {
      title: "Level",
      dataIndex: "Level",
    },
    {
      title: "Joined At",
      dataIndex: "JoinedAt",
      render: (date) => new Date(date).toLocaleString(),
    },
    {
      title: "Status",
      dataIndex: "Active",
      render: (active) => (active ? "Active" : "Inactive"),
    },
  ];

  return (
    <>
      <Title
        style={{ fontFamily: "Inter, sans-serif", marginBottom: "16px" }}
        level={2}
      >
        <TeamOutlined />&nbsp; Downline Users
      </Title>

      {/* <Row
        style={{
          padding: "20px",
          backgroundColor: darkmode ? "#141414" : "#0d0a0a",
          borderRadius: "5px",
          marginBottom: "20px",
        }}
      >
        <Col flex="auto">
          <Breadcrumb
            items={[{ title: "Network" }, { title: "Downline" }]}
            style={{ marginBottom: "5px" }}
          />
        </Col>
      </Row> */}

      <Card title="My Downline">
        <Table
          columns={columns}
          dataSource={data?.downlines || []}
          loading={isLoading}
          rowKey={(row) => row.ID}
          pagination={{ pageSize: 10 }}
          scroll={{ x: "max-content" }}
        />
      </Card>
    </>
  );
};

export default DownlinePage;